import request from './common/request'

import { MERCHANT_FINANCE_TRANSACTION_URL } from './urls'

async function list (params) {
  return request({
    url: MERCHANT_FINANCE_TRANSACTION_URL,
    method: 'GET',
    params: params
  })
}

async function applyRefund (id) {
  return request({
    url: `${MERCHANT_FINANCE_TRANSACTION_URL}/${id}/apply_refund`,
    method: 'PUT'
  })
}

async function cancelRefund (id) {
  return request({
    url: `${MERCHANT_FINANCE_TRANSACTION_URL}/${id}/cancel_refund`,
    method: 'PUT'
  })
}

export default {
  list,
  applyRefund,
  cancelRefund
}



// WEBPACK FOOTER //
// ./src/api/merchant-finance-transaction.js